import { EHeadingStyleVariant, ETextStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import dayjs from 'dayjs';
import React from 'react';
import { useIntl } from 'react-intl';

import Image from '@/components/route/blog/BlogPostImage/Image';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { IImages } from '@/services/types/blog/post.types';

type TBlogPostInlineHeroProps = {
  title: string | null;
  author: string | null;
  date: string | null;
  images: IImages | null;
  timeToRead?: number; // mins
};

export const BlogPostInlineHero = ({
  title,
  author,
  date,
  images,
  timeToRead,
}: TBlogPostInlineHeroProps) => {
  const intl = useIntl();
  const { isMobile } = useBreakpoint();

  return (
    <div>
      {title && (
        <Heading
          variant={isMobile ? EHeadingStyleVariant.H3 : EHeadingStyleVariant.H1}
          className="text-center">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Heading>
      )}

      {(author || date) && (
        <Text variant={ETextStyleVariant.LargeBold} className="my-4 text-center md:my-6">
          {author && <span>{author}</span>}
          {author && date && <span className="mx-2">&bull;</span>}
          {date && <span>{dayjs(date).format('MMMM D, YYYY')}</span>}

          {timeToRead && (
            <>
              {(author || date) && <span className="mx-2">&bull;</span>}
              <span>
                {intl.formatMessage(
                  {
                    defaultMessage: '{timeToRead} min read',
                    id: 'ALkK8L',
                  },
                  { timeToRead },
                )}
              </span>
            </>
          )}
        </Text>
      )}

      <div className="relative w-full my-6 overflow-hidden md:my-8 rounded-md h-[215px] md:h-[440px]">
        <Image
          images={images}
          title={title || 'Outdoorsy Blog Post Main Image'}
          className="object-cover w-full h-full"
          priority={true}
          quality={65}
        />
      </div>
    </div>
  );
};
